import React from 'react';
import { signIn } from 'next-auth/react';

/**
 * A reusable button component for social login providers
 * @param {Object} props - Component props
 * @param {string} props.provider - The authentication provider (e.g., 'google')
 * @param {string} props.text - The button text
 * @param {string} props.icon - SVG icon markup for the provider
 * @param {string} props.bgColor - Background color of the button
 * @param {string} props.textColor - Text color of the button
 * @param {string} props.hoverBgColor - Background color on hover
 * @param {Function} props.onClick - Optional callback function
 * @param {boolean} props.fullWidth - Whether the button should take full width
 * @param {string} props.className - Additional CSS classes
 */
const SocialButton = ({
  provider,
  text,
  icon,
  bgColor = 'bg-white',
  textColor = 'text-gray-700',
  hoverBgColor = 'hover:bg-gray-50',
  onClick,
  fullWidth = true,
  className = '',
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    signIn(provider, { callbackUrl: '/dashboard' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm ${textColor} ${bgColor} ${hoverBgColor} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      <span className="mr-2">{icon}</span>
      <span>{text}</span>
    </button>
  );
};

export default SocialButton;
